import type {AuthStartResponse,GoogleAuthIntent} from '@reados/contracts';

export interface AuthCallbackNotice {kind:'error'|'success';message:string}
const callbackErrors:Record<string,string>={
 google_disabled:'Google 登录暂未开放，请使用邮箱和密码登录。',
 google_cancelled:'已取消 Google 授权，你可以重新尝试或使用邮箱登录。',
 google_invalid_state:'Google 授权已过期或无法验证，请重新发起登录或关联。',
 google_failed:'Google 授权未完成，请稍后重试。',
 google_unverified_email:'请先在 Google 验证邮箱，再重新尝试。',
 account_exists:'该邮箱已有 ReadOS 账号。请先使用邮箱和密码登录，再在设置中关联 Google 账号。',
 registration_disabled:'当前暂未开放创建账号，请使用已有账号登录。',
 google_already_linked:'无法关联：此 Google 账号已关联其他 ReadOS 账号，或当前 ReadOS 账号已关联其他 Google 账号。',
 google_session_changed:'登录状态已变化。请确认当前 ReadOS 账号，再从设置中重新关联 Google 账号。'
};

/** Callback text is selected from a fixed map; provider/URL text is never rendered. */
export function readAuthCallback(href:string):{notice:AuthCallbackNotice|null;cleanUrl:string|null}{
 const url=new URL(href),error=url.searchParams.get('authError'),linked=url.searchParams.get('auth')==='google-linked';
 const notice:AuthCallbackNotice|null=error!==null?{kind:'error',message:callbackErrors[error]||callbackErrors.google_failed}:linked?{kind:'success',message:'已关联 Google 账号，以后可以使用 Google 登录。'}:null;
 if(error===null&&!linked)return {notice,cleanUrl:null};
 url.searchParams.delete('authError');
 if(linked)url.searchParams.delete('auth');
 return {notice,cleanUrl:`${url.pathname}${url.search}${url.hash}`};
}

export function googleAuthDestination(value:string):string{
 let url:URL;try{url=new URL(value);}catch{throw new Error('Google 登录地址无效，请稍后重试。');}
 if(url.origin!=='https://accounts.google.com'||url.pathname!=='/o/oauth2/v2/auth'||url.username||url.password)throw new Error('Google 登录地址无效，请稍后重试。');
 return url.href;
}

/** One server-started authorization per action; linking is always an explicit intent. */
export async function startGoogleNavigation(intent:GoogleAuthIntent,start:(intent:GoogleAuthIntent)=>Promise<AuthStartResponse>,navigate:(url:string)=>void):Promise<void>{
 const result=await start(intent);
 navigate(googleAuthDestination(result.url));
}
